/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import {
  useAuthStore,
  usePrePanStore,
  usePostPanStore,
  useUIControlsStore,
} from './redux/index';
import { WELCOME_SCR, GET_NAME } from './components/pre-pan-journey/screens';

export const RouteChangeDetector = () => {
  const { pathname } = useLocation();

  let nextScreens;
  const { showReferralScreen } = useAuthStore();
  const { blockId, onScreenComp, updateBlockId, updateOnScreenComp } =
    usePrePanStore();
  const { completeProfileRoute } = useUIControlsStore();

  const {
    detailsType,
    allScreens,
    updateSalaryConfirmation,
    onScreenComp: postpanOnScreenComp,
    updateOnScreenComp: postpanUpdateOnScreenComp,
  } = usePostPanStore();

  useEffect(() => {
    // console.log('Route changed to: ', pathname);

    // NOTE: handling to show the pre-pan welcome screen only once in a session
    // When the user goes to  dahboard or any other route and comes back to prepan/postpan user will be shown the first screen
    if (
      (showReferralScreen || completeProfileRoute === '/pre-pan') &&
      pathname !== '/pre-pan'
    ) {
      nextScreens = [GET_NAME];
      updateBlockId(1);
      updateOnScreenComp(nextScreens);
    } else if (
      completeProfileRoute === '/post-pan' &&
      pathname !== '/post-pan'
    ) {
      if (allScreens[0] === 'WELCOME_SCR') {
        postpanUpdateOnScreenComp([allScreens[1]]);
      } else {
        postpanUpdateOnScreenComp([allScreens[0]]);
      }
      if (detailsType === 'FORM') {
        updateSalaryConfirmation(false); // DOCS: this is needed if the user has moved to 2nd screen of view and changes route when user comes back to /post-pan user is supposes to land on 1st screen of form view
      }
    }
  }, [pathname]);
};
